import { TileLayer } from '@deck.gl/geo-layers';
import { parse } from '@loaders.gl/core';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

const CUZK_CIR_WMS_URL =
  'https://geoportal.cuzk.gov.cz/WMS_ORTOFOTO_CIR/service.svc/get';

export const CUZK_CIR_YEAR = '2025';

export function getCuzkCirTileUrl(
  west: number,
  south: number,
  east: number,
  north: number,
  year: string = CUZK_CIR_YEAR
): string {
  const bbox = `${south},${west},${north},${east}`;

  return (
    `${CUZK_CIR_WMS_URL}?format=image/png&bbox=${bbox}` +
    '&crs=EPSG%3A4326&request=GetMap&width=256&height=256&service=WMS' +
    `&transparent=TRUE&version=1.3.0&layers=${year}&styles=`
  );
}

export const cuzkCirLayer = (year: string = CUZK_CIR_YEAR) =>
  new TileLayer({
    id: `cuzk-cir-layer-${year}`,
    getTileData: async ({ bbox }) => {
      const { east, south, north, west } = geoBbox(bbox);
      const result = await fetch(
        getCuzkCirTileUrl(west, south, east, north, year)
      );
      const data = await parse(result);

      return data;
    },
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 1,
    renderSubLayers: renderBitmapTileSubLayer,
  });
